import {PAdbContext} from "../PA.Core/PAdbContext";
import {AuditService} from "../PA.Core/Security/AuditService";
import {ApprovalBO} from "./ApprovalBO";
import {auditFieldFK, AuditUtils, IAuditField} from "../PA.Core/Basic/AuditUtils";
import {AuditLogType} from "../PA.Core/PA.Core.IF.Audit";
import {WB_ApprovalRow} from "../PA.Core/PAdbSchemaRows";
import * as _ from "lodash";

export class ApprovalBOAudit {


    static async ApprovalAuditBO(ApprovalBO: ApprovalBO): Promise<AuditService> {

        const self = ApprovalBO
        const auditService = new AuditService(self.dbContext)
        auditService.setReference("Approval", self.drWB_Approval.cif.WB_APPROVAL_ID)

        // @ts-ignore
        self.deleteKeys = self.deleteKeys || {}
        // @ts-ignore
        let deleteKeys: any = self.deleteKeys

        const approvalParams: IAuditField [] = [
            {fieldName: "APPROVAL_NAME",              realName: "Name", bAllMsg: true }, //create
            {fieldName: "APPROVAL_ID",                realName: "ID",  bAllMsg: true }, //create
            {fieldName: "APPROVAL_TYPE_ID",  realName: "Type",  },
            {fieldName: "APPROVAL_SUBTYPE_ID",        realName: "Sub Type"},
            {fieldName: "WB_BUSINESSUNIT_ID",          realName: "Business Unit"},
            {fieldName: "WB_MDSET_ID",                 realName: "Master Data Set"},
            {fieldName: "APPROVAL_SUBSET_ID",         realName: "Approval Subset"},
            {fieldName: "EVALUATION_ORDER",       realName: "Evaluation Order"},
            {fieldName: "EFFECTIVE_START_DT",         realName: "Effective Start Date"},
            {fieldName: "EFFECTIVE_END_DT",          realName: "Effective End Date"},
            {fieldName: "APPROVAL_NOTES",          realName: "Notes"},
            {fieldName: "WB_CUST_ID",          realName: "Customer Type"},
            {fieldName: "WB_EVTSTYPE_ID",          realName: "Tactic Type"},
            {fieldName: "WB_EVTTYPE_ID",          realName: "Event Type"},
            {fieldName: "RATEBASIS_OPTIONS",          realName: "Rate Basis"},
            {fieldName: "RATEUOM_OPTIONS",          realName: "Rate UOM"},
            {fieldName: "PAYMENTMETHOD_OPTIONS",          realName: "Payment Method"},
            {fieldName: "USE_RANGE_IND",          realName: "Use Range"},
            {fieldName: "RANGE_BOUND_TYPE",          realName: "Range Type"},
            {fieldName: "RANGE_LOWER_BOUND_AMT",          realName: "Lower Bound"},
            {fieldName: "RANGE_UPPER_BOUND_AMT",          realName: "Upper Bound"},
            {fieldName: "APPROVAL_ACTION",                realName: "Approval Action"},
            {fieldName: "REVISED_THRESHOLD_FIXED_AMT",    realName: "Fixed Amt"},
            {fieldName: "REVISED_THRESHOLD_PCNT",             realName: "Percent", decimalCount: 2},
            {fieldName: "REQUIRED_ROLE_ID",        realName: "Required Role" },

        ]

        // Execute Audit Logging
        await AuditUtils.logRecord(auditService, self.WB_Approval, approvalParams, {objectName: 'Approval', deletedKeys: deleteKeys})


        return auditService
    }



}
